/* eslint-disable react-hooks/exhaustive-deps */
import CustomModal from '@/components/CustomModal';
import RecommendBonusCard from '@/pages/rights/bonus/components/RecommendBonusCard';
import { jsShowAppReviewDialog, openNewWebview } from '@/utils/bridge';
import { useMounted, useUpdate } from '@/utils/hooks';
import { reportClick, reportPage } from '@/utils/report';
import { hideToast, showLoadingToast } from '@/utils/utils';
import { ListView } from 'antd-mobile';
import { connect } from 'dva';
import { useCallback, useEffect, useRef, useState } from 'react';
import NoData from '../components/NoData';
import CardStatusTabs from '../components/StatusTabs';
import {
  BOUNS_STATUS_INFO,
  BOUNS_UNUSED_STATUS,
  BOUNS_USING_STATUS,
  MODULE,
  PAGE_SIZE,
} from '../config';
import styles from '../styles/bonus.less';
import BounsCard from './components/BounsCard';
import UseBounsCardModal from './components/UseBounsCardModal';

const PAGE_NAME = 'bonus_card';

const BounsCardPage = ({
  rights: { bonusCardList, isBounsCardListAll, bonusCardAdList },
  dispatch,
  loading,
}) => {
  const showQueryRef = useRef(true);
  const [showUseModal, setShowUseModal] = useState(false);
  const [showBindTip, setShowBindTip] = useState(false);
  const [curCardInfo, setCurCardInfo] = useState({});
  const [curDeviceInfo, setCurDeviceInfo] = useState({});
  const [adModelVisible, setAdModelVisible] = useState(false);
  // 列表筛选项
  const [filterOptions, setFilterOptions] = useState({
    page: 1,
    pageSize: PAGE_SIZE,
    status: `${BOUNS_UNUSED_STATUS}`,
  });

  const handleGetBonusCardAdList = () => {
    dispatch({
      type: 'rights/getBonusCardAdList',
      payload: {
        userType: 1,
      },
    });
  };

  const handleCardStatusChange = useCallback(
    status => {
      showQueryRef.current = true;
      setFilterOptions({
        ...filterOptions,
        page: 1,
        status,
      });
      handleGetBonusCardAdList();
    },
    [filterOptions]
  );

  let dataSource = new ListView.DataSource({ rowHasChanged: (r1, r2) => r1 !== r2 });
  dataSource = dataSource.cloneWithRows(bonusCardList);

  const renderListFooter = useCallback(() => {
    let footerText = '';
    if (loading) footerText = '加载中...';
    if (isBounsCardListAll) footerText = '- 没有更多啦 -';
    return <div style={{ textAlign: 'center' }}>{footerText}</div>;
  }, [isBounsCardListAll, loading]);

  const handleListEndReached = useCallback(() => {
    if (isBounsCardListAll || loading) return;
    console.log('到底啦');
    showQueryRef.current = true;
    setFilterOptions({
      ...filterOptions,
      page: filterOptions.page + 1,
    });
  }, [isBounsCardListAll, filterOptions, loading]);

  const queryDeviceListForBounsCard = useCallback(() => {
    const { cardCode, filter } = curCardInfo;
    dispatch({
      type: 'rights/getBounsDeviceList',
      payload: {
        cardId: cardCode,
        filter: filter,
      },
      callback: () => {
        hideToast();
        setShowUseModal(true);
      },
    });
  }, [curCardInfo]);

  const handleCardItemClick = useCallback(
    cardInfo => {
      console.log('cardInfo: ', cardInfo);
      switch (cardInfo.status) {
        case BOUNS_UNUSED_STATUS:
          showLoadingToast();
          setCurCardInfo({
            ...curCardInfo,
            ...cardInfo,
            filter: '',
          });
          break;
        case BOUNS_USING_STATUS:
          openNewWebview({
            url: `${window.location.origin}/income/device/${cardInfo.deviceAccountId}`,
          });
          break;
        default:
          break;
      }
    },
    [curCardInfo]
  );

  const row = useCallback(
    item => <BounsCard handleCardClick={handleCardItemClick} key={item.cardCode} data={item} />,
    []
  );

  const getBounsCardList = useCallback(() => {
    dispatch({
      type: 'rights/getBounsCardList',
      payload: { ...filterOptions },
      successCallback: () => {
        hideToast();
        showQueryRef.current = true;
      },
      failCallback: () => {
        showQueryRef.current = false;
        setFilterOptions({
          ...filterOptions,
          page: filterOptions.page > 1 ? filterOptions.page - 1 : 1,
        });
      },
    });
  }, [filterOptions, showQueryRef]);

  const handleSearchInputChange = useCallback(
    inputVal => {
      setCurCardInfo({
        ...curCardInfo,
        filter: inputVal,
      });
    },
    [curCardInfo]
  );

  const handleBindDeviceWithCard = useCallback(
    device => {
      reportClick({
        page_name: PAGE_NAME,
        button_name: 'use_btn',
        sn: device.sn,
      });
      setShowBindTip(true);
      setCurDeviceInfo({ ...device });
    },
    [curCardInfo]
  );

  const ajaxBindWithCard = useCallback(
    deviceInfo => {
      showLoadingToast();
      dispatch({
        type: 'rights/bindDeviceWithBounsCard',
        payload: {
          cardId: curCardInfo.cardCode,
          sn: deviceInfo.sn,
          deviceAccountId: deviceInfo.deviceAccountId,
        },
        callback: () => {
          setShowBindTip(false);
          setShowUseModal(false);
          jsShowAppReviewDialog({ scene: 'bonus_card' });
        },
      });
    },
    [curCardInfo]
  );

  useEffect(() => {
    if (bonusCardAdList?.length > 0) {
      setAdModelVisible(true);
    }
  }, [bonusCardAdList]);

  useEffect(() => {
    if (showQueryRef.current) {
      if (filterOptions.page === 1) {
        window.scrollTo(0, 0);
        showLoadingToast();
      }
      getBounsCardList();
    }
  }, [filterOptions]);

  useUpdate(() => {
    queryDeviceListForBounsCard();
    handleGetBonusCardAdList();
  }, [curCardInfo]);

  useMounted(() => {
    reportPage({
      module: MODULE,
      page_name: PAGE_NAME,
    });
    handleGetBonusCardAdList();
  });

  return (
    <div className={styles.bonusPage}>
      <CardStatusTabs
        statusInfo={BOUNS_STATUS_INFO}
        curStatus={filterOptions.status}
        onStatusChange={handleCardStatusChange}
      />
      {/* <bonus card recommend /> */}
      {adModelVisible && <RecommendBonusCard recommendInfo={bonusCardAdList} />}
      {/* <ActBounsCard /> */}
      {bonusCardList.length > 0 ? (
        <ul className={styles.bonusCardList}>
          <ListView
            initialListSize={PAGE_SIZE}
            dataSource={dataSource}
            renderFooter={renderListFooter}
            renderRow={row}
            pageSize={PAGE_SIZE}
            useBodyScroll
            scrollRenderAheadDistance={500}
            onEndReached={handleListEndReached}
            onEndReachedThreshold={10}
          />
        </ul>
      ) : (
        !loading && <NoData className={styles.noData} text="您还没有加成卡" />
      )}
      {showUseModal && (
        <UseBounsCardModal
          onClose={() => setShowUseModal(false)}
          queryDeviceList={handleSearchInputChange}
          handleBindDevice={handleBindDeviceWithCard}
        />
      )}
      <CustomModal
        visible={showBindTip}
        title="温馨提示"
        cancelText="取消"
        okText="确定"
        cancelCallback={() => setShowBindTip(false)}
        okCallback={() => ajaxBindWithCard(curDeviceInfo)}
        needFixedBody={false}
      >
        <div
          className={styles['confirm-text']}
          dangerouslySetInnerHTML={{
            __html:
              curDeviceInfo.bindCardMsg || '加成卡使用后不可撤销，另外保持设备稳定在线收益更高哦～',
          }}
        />
      </CustomModal>
    </div>
  );
};
export default connect(({ rights, loading }) => ({
  rights,
  loading: loading.effects['rights/getBounsCardList'],
}))(BounsCardPage);
